import { useState } from 'react';
import "./ImageCard.css"
import "../../styles/Press.css"
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ImageCard = ({ imageName, source, scrollPosition }) => {
  const [isFullScreen, setIsFullScreen] = useState(false)

  const toggleFullScreen = () => {
    setIsFullScreen(prev => !prev)
  }

  const lastDotIndex = imageName.lastIndexOf('.');

  const processedImageName = imageName.substring(0, lastDotIndex).replaceAll("_", " ")

  return (
    <>
      <div 
        className="image-card"
        onClick={toggleFullScreen}
      >
        <LazyLoadImage
          className='galleryImg' 
          src={source} 
          alt={imageName}
          scrollPosition={scrollPosition}
        />
        <p className='galleryImgCaption'>{processedImageName}</p>
      </div>

      {isFullScreen && (
        <div className="fullscreen-overlay" onClick={toggleFullScreen}>
          <div>
          <button className="fullscreen-close">×</button>
            <img 
              src={source} 
              alt={imageName} 
              className="fullscreen-image"
            />
            <div className="fullscreen-caption">
              <p>{processedImageName}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ImageCard